import { render, staticRenderFns } from "./set-oncall-rule.vue?vue&type=template&id=16314e55&"
import script from "./set-oncall-rule.vue?vue&type=script&lang=ts&"
export * from "./set-oncall-rule.vue?vue&type=script&lang=ts&"
import style0 from "./set-oncall-rule.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports